import { useTranslation } from '@/hooks/use-translation'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

interface CtaSettingsProps {
  actionLabel: string
  actionUrl: string
  onActionLabelChange: (value: string) => void
  onActionUrlChange: (value: string) => void
  actionLabelError?: string
  actionUrlError?: string
}

export function CtaSettings({
  actionLabel,
  actionUrl,
  onActionLabelChange,
  onActionUrlChange,
  actionLabelError,
  actionUrlError,
}: CtaSettingsProps) {
  const { t } = useTranslation()

  return (
    <div className='space-y-4'>
      <Label>{t('surveys.callToActionSettings')}</Label>

      <div className='space-y-2'>
        <Label htmlFor='action-label'>{t('surveys.buttonText')}</Label>
        <Input
          id='action-label'
          value={actionLabel}
          onChange={(e) => onActionLabelChange(e.target.value)}
          placeholder={t('surveys.buttonTextPlaceholder')}
          className={actionLabelError ? 'border-red-500' : ''}
        />
        {actionLabelError && (
          <p className='text-sm text-red-600'>{actionLabelError}</p>
        )}
      </div>

      <div className='space-y-2'>
        <Label htmlFor='action-url'>{t('surveys.actionUrl')}</Label>
        <Input
          id='action-url'
          value={actionUrl}
          onChange={(e) => onActionUrlChange(e.target.value)}
          placeholder='https://example.com'
          type='url'
          className={actionUrlError ? 'border-red-500' : ''}
        />
        {actionUrlError && (
          <p className='text-sm text-red-600'>{actionUrlError}</p>
        )}
      </div>

      <div className='text-sm text-muted-foreground'>
        <p>{t('surveys.ctaDescription')}</p>
      </div>
    </div>
  )
}
